module.exports = __webpack_public_path__ + "static/media/schwangerschaftkurse.3e4fd736.jpg";